import { ActionButtonType } from '../../../view-data/components/toggle-view/action-button-type';
import { DropdownItem } from '../../../../shared/dropdown-item';
var ActionButtonTypeHelper = /** @class */ (function () {
    function ActionButtonTypeHelper() {
    }
    ActionButtonTypeHelper.getButtonTypes = function () {
        return [new DropdownItem(ActionButtonType.toggle, 'ToggleView'),
            new DropdownItem(ActionButtonType.pop, 'PopView'),
            new DropdownItem(ActionButtonType.close, 'CloseView'),
            new DropdownItem(ActionButtonType.control, 'ControlViewBar')];
    };
    ActionButtonTypeHelper.getButtonValue = function (type) {
        var result = 'ToggleViewTo';
        switch (+type) {
            case ActionButtonType.pop:
                result = 'SelectPopView';
                break;
            case ActionButtonType.close:
                result = 'CloseView';
                break;
        }
        return result;
    };
    return ActionButtonTypeHelper;
}());
export { ActionButtonTypeHelper };
